export function getSearchableCities(searchValue, citiesList) {
  if (!searchValue) return [];
  if (!citiesList?.cities) return [];
  return Object.values(citiesList.cities)
    .filter(({ he }) => {
      return he.includes(searchValue);
    })
    .map((c) => {
      return { name: c.he, id: c.id, area: citiesList.areas[c.area].he };
    })
    .slice(0, 50);
}

export function getSearchableAreas(searchValue, citiesList) {
  if (!searchValue) return [];
  if (!citiesList?.areas) return [];
  return Object.entries(citiesList.areas)
    .filter(([id, { he }]) => {
      return he.includes(searchValue);
    })
    .map(([id, c]) => {
      return { name: c.he, id: Number(id) };
    })
    .slice(0, 50);
}

export function getNamesFromCitiesIds(citiesIds, citiesList) {
  if (!citiesIds) return [];
  if (!citiesList?.cities) return [];
  return Object.values(citiesList.cities)
    .filter(({ id }) => {
      return citiesIds.includes(id);
    })
    .map((c) => {
      return { name: c.he, id: c.id, area: citiesList.areas[c.area].he };
    });
}

export function getNamesFromAreasIds(areasIds, citiesList) {
  if (!areasIds) return [];
  if (!citiesList?.areas) return [];
  const x = Object.entries(citiesList.areas)
    .filter(([id, { he }]) => {
      return areasIds.includes(Number(id));
    })
    .map(([id, c]) => {
      return { name: c.he, id: Number(id) };
    });

  return x;
}
